// extracted by mini-css-extract-plugin
export var videoSection = "Video-module--videoSection--8GvHO";